// What each athlete profile metric means (Kobi, 11/04): the short line is
// always visible under the card title, the long text opens from the (i)
// beside it (MetricInfo.js). One copy for every web surface that draws these
// cards: the athlete's own profile, the coach/rep/brand/staff view, the phone
// tabs and the public share page. The native app carries the same strings in
// mobile/, word for word.
//
// `name` is the title without the ™, for the (i)'s accessible name
// ("About CacheScore"). `entries` are labelled lines under the long text:
// the three pillars, and the rate card's deliverables (the labels the rate
// rows already use). PerformanceValue (the card in CacheValue's slot for an
// athlete who has not onboarded) keeps its own short line; its long text is
// ours, not Kobi's, until the owner words it.
export const METRIC_INFO = {
  cacheScore: {
    title: "CacheScore™",
    name: "CacheScore",
    short: "Overall brand strength indicator",
    long: "A composite score of an athlete's overall brand strength. It blends performance, visibility, and off-court impact into a single rating.",
  },
  contributions: {
    title: "Contributions™",
    name: "Contributions",
    short: "Performance, visibility & influence breakdown",
    entries: [
      { label: "Performance", text: "A measure of on-court production and athletic output." },
      {
        label: "Visibility",
        text: "An athlete's social and media reach. How widely known and followed they are across platforms and coverage.",
      },
      {
        label: "Off-court Impact",
        text: "An athlete's real-world engagement and presence beyond the game. Reflects how they connect with community off the court in real life.",
      },
    ],
  },
  cacheValue: {
    title: "CacheValue™",
    name: "CacheValue",
    short: "Performance-driven value",
    long: "An athlete's total commercial on-court value. What their overall performance and production are worth in the market.",
  },
  performanceValue: {
    title: "PerformanceValue™",
    name: "PerformanceValue",
    short: "Estimated from performance",
    long: "An estimate of an athlete's on-court value from performance alone. It is shown until the athlete completes onboarding and their full CacheValue is computed.",
  },
  cacheNilx: {
    title: "CacheNILx™ Value",
    name: "CacheNILx Value",
    short: "Brand and endorsement value",
    long: "An athlete's brand and endorsement value. What their name, image, and audience reach are worth to sponsors.",
  },
  nilxRates: {
    title: "NILx™ Rate Card",
    name: "NILx Rate Card",
    short: "Per-deliverable NIL rates derived from the athlete's social media.",
    long: "Suggested rates for individual brand deliverables, derived from the athlete's overall NILx value. Each figure estimates what a sponsor might pay for a single piece of content or appearance.",
    entries: [
      { label: "Events", text: "Rate for an in-person appearance or event." },
      { label: "Social Media Post", text: "Rate for a single static feed post." },
      { label: "Reel / TikTok", text: "Rate for a short-form video." },
      { label: "Story", text: "Rate for a temporary story post." },
      { label: "Long form video", text: "Rate for a dedicated long-form video." },
      { label: "Repost", text: "Rate for sharing or reposting brand content." },
    ],
  },
};

// The (i)'s accessible name for a metric: "About CacheScore".
export const metricInfoLabel = (metric) => `About ${METRIC_INFO[metric]?.name || "this metric"}`;

// The action the CacheValue description offers when the page can open the
// CacheValue in context modal.
export const CONTEXT_ACTION = "See CacheValue in context";
